export type SectionTheme = "ink" | "paper";

export type RailSection = {
  id: string;
  index: string;
  label: string;
  theme: SectionTheme;
};

export type NavLink = {
  href: string;
  label: string;
};

/** Pill navigation — 5 odkazů dle BUILD CONTRACT. */
export const pillLinks: NavLink[] = [
  { href: "#duvody", label: "Proč" },
  { href: "#co-resi", label: "Co řád řeší" },
  { href: "#proces", label: "Postup" },
  { href: "#cenik", label: "Ceník" },
  { href: "#faq", label: "FAQ" },
];

/** Rejstříkový pruh — §01…§12, jediný opakující se dekorativní prvek. */
export const railSections: RailSection[] = [
  { id: "hero", index: "01", label: "Úvod", theme: "ink" },
  { id: "duvody", index: "02", label: "Důvody", theme: "ink" },
  { id: "co-resi", index: "03", label: "Co řád řeší", theme: "paper" },
  { id: "prinosy", index: "04", label: "Přínosy", theme: "paper" },
  { id: "srovnani", index: "05", label: "B2B × B2C", theme: "paper" },
  { id: "proces", index: "06", label: "Postup", theme: "paper" },
  { id: "pro-koho", index: "07", label: "Pro koho", theme: "paper" },
  { id: "video", index: "08", label: "Video", theme: "ink" },
  { id: "faq", index: "09", label: "FAQ", theme: "paper" },
  { id: "cenik", index: "10", label: "Ceník", theme: "paper" },
  { id: "poptavka", index: "11", label: "Poptávka", theme: "ink" },
  { id: "cta", index: "12", label: "Nabídka", theme: "ink" },
];

export const footerNav: NavLink[] = pillLinks;

export const legalNav: NavLink[] = [
  { href: "/obchodni-podminky/", label: "Obchodní podmínky" },
  { href: "/ochrana-osobnich-udaju/", label: "Ochrana osobních údajů" },
  { href: "/cookies/", label: "Cookies" },
];
